import {
  FETCH_DISTRIBUTORS_SUCCESS_ACTION,
  FETCH_DETAILVIEW_SUCCESS_ACTION,
  FETCH_DISTRIBUTORSTATUS_SUCCESS_ACTION,
  FETCH_DISTRIBUTOR_USERS_INIT_ACTION,
  FETCH_DISTRIBUTOR_USERS_SUCCESS_ACTION,
  FETCH_DISTRIBUTOR_USERS_FAIL_ACTION
} from "./action";

const initialState = {
  processing: false,
  error: false
};

export default function(state: any = initialState, action: Function) {
  switch (action.type) {
    case FETCH_DISTRIBUTORS_SUCCESS_ACTION:
      // console.log(action.payload);
      return {
        ...state,
        DistributorsList: action.payload.rows,
        DistributorsCount: action.payload.count
      };

    case FETCH_DETAILVIEW_SUCCESS_ACTION:
      return {
        ...state,
        distributorDetail: action.payload
      };

    case FETCH_DISTRIBUTORSTATUS_SUCCESS_ACTION:
      return {
        ...state,
        distributorStatus: action.payload
      };

    case FETCH_DISTRIBUTOR_USERS_INIT_ACTION:
      return {
        ...state,
        distributorUsers: [],
        distributorUsersCount: 0,
        distributorUsersLoading: true
      };

    case FETCH_DISTRIBUTOR_USERS_SUCCESS_ACTION:
      return {
        ...state,
        distributorUsers: action.payload.rows ? action.payload.rows : [],
        distributorUsersCount: action.payload.count ? action.payload.count : 0,
        distributorUsersLoading: false
      };

    case FETCH_DISTRIBUTOR_USERS_FAIL_ACTION:
      return {
        ...state,
        distributorUsers: [],
        distributorUsersCount: 0,
        distributorUsersLoading: false
      };

    default:
      return {
        ...state
      };
  }
}
